export default function TechnicalApplicationsSection() {
  const applications = [
    {
      title: 'Pressure Equipment',
      description: 'Pressure vessels, heat exchangers, storage tanks, piping systems manufactured to ASME Section VIII, PED 2014/68/EU, or EN 13445 requirements.',
    },
    {
      title: 'Structural Steel Components',
      description: 'Fabricated steel structures for offshore installations, industrial facilities, and energy infrastructure. Welding quality requirements assessed against ISO 3834 principles and AWS D1.1 requirements.',
    },
    {
      title: 'Protective Coating Systems',
      description: 'Surface preparation and coating application monitoring per ISO 12944 and NORSOK M-501 requirements. Inspection activities include surface cleanliness verification, coating thickness measurement, and holiday detection.',
    },
    {
      title: 'Piping Systems',
      description: 'Fabrication surveillance for process piping, pipeline systems, and piping assemblies per ASME B31.1, B31.3, or project-specific specifications.',
    },
  ];

  return (
    <section className="py-28 px-8 bg-light-section">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white border border-light-border rounded-full mb-6">
            <span className="text-industrial-steel text-xs font-medium tracking-[0.12em] uppercase">
              Technical Applications
            </span>
          </div>
          <h2 className="font-serif text-dark-primary text-4xl leading-tight mb-6">
            Equipment and Component Categories
          </h2>
        </div>

        {/* Applications Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {applications.map((app) => (
            <div key={app.title} className="bg-white border border-light-border rounded-lg p-8">
              <h3 className="text-dark-primary text-base font-semibold mb-4 tracking-wide">
                {app.title}
              </h3>
              <p className="text-industrial-steel text-sm leading-[1.75]">
                {app.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}